module.exports = require("core-js/modules/es.typed-array.filter.js");